import React from 'react'

function SurveyorDashboard() {
  return (
    <div>SurveyorDashboard</div>
  )
}

export default SurveyorDashboard